import { Copy, Check } from 'lucide-react'
import { BaseDialog, BaseInput, BaseButton } from '@/shared/components'
import { useToast } from '@/shared/hooks'
import { useState } from 'react'

type Props = {
  modalVisible: boolean
  setModalVisible: (value: boolean) => void
  referralLink: string
}

export const ShareLinkDialog = ({ modalVisible, setModalVisible, referralLink }: Props) => {
  const { addToast } = useToast()
  const [isCopying, setIsCopying] = useState(false)

  const handleCopy = async () => {
    try {
      setIsCopying(true)
      await navigator.clipboard.writeText(referralLink)
      addToast('Успех!', 'Ссылка скопирована в буфер обмена', 'success')
    } catch (err) {
      addToast('Ошибка!', 'Не удалось скопировать ссылку', 'error')
    } finally {
      setTimeout(() => setIsCopying(false), 1000)
    }
  }
  const iconClasses = 'text-primary dark:text-primary-dark max-h-5 max-w-6'
  return (
    <BaseDialog
      isVisible={modalVisible}
      onClose={() => setModalVisible(false)}
      title="Поделиться реферальной ссылкой"
      xButton={true}
      //   iconTitle={
      //     <div className="flex p-3 rounded-full bg-primary-dark-disabled">
      //       <Share className="w-5 h-5 text-primary dark:text-primary-dark" />
      //     </div>
      //   }
      isLoading={isCopying}
    >
      <div className="flex flex-col gap-6 items-start ">
        <p className="text-[20px]"></p>
        <div className="w-full flex flex-col gap-3">
          <BaseInput
            label="Ваша реферальная ссылка"
            variant="secondary"
            className="text-sm"
            value={referralLink}
            readOnly
            optionInputClasses="text-primary dark:text-primary-dark"
          />
          <BaseButton
            variant="outlined"
            padding="md"
            onClick={handleCopy}
            disabled={isCopying}
            icon={isCopying ? <Check className={iconClasses} /> : <Copy className={iconClasses} />}
          >
            {isCopying ? 'Скопировано' : 'Скопировать'}
          </BaseButton>
        </div>
      </div>
    </BaseDialog>
  )
}
